module.exports = __webpack_public_path__ + "static/media/selected_marker_stormwater.c11452cf.svg";